module.exports = __webpack_public_path__ + "9fdcf7a65de241b4f25ec0ccff7f3e1d.png";


//////////////////
// WEBPACK FOOTER
// ./shared/components/Logo/assets/beige/eukdlx.png
// module id = 2394
// module chunks = 0